import {Location} from "../models/Location"
import {UntypedFormControl} from '@angular/forms';
import {SubscriptionModel, SubscriptionItem} from '../models/Subscriptions';
import {ControlantChoice} from '../modules/shared/components/search-select/search-select.component';
import {User} from "../models/User";
import {UserHelpers} from "./user.helpers";
import {scan} from "rxjs/operators";
import { LocationsService } from "../services/locations.service";

export class SubscriptionHelpers {
    public static findLocation(locations: Location[], id: number): Location {
        if (id !== null) {
            const loc = locations.find((location: Location) => location.id === id);
            if (loc) {
              return loc;
            }
        }
        return null;
    }

    public static async findLocationAsync(locations: Location[], id: number, locationService: LocationsService): Promise<Location> {
        if (id !== null) {
            const loc = locations.find((location: Location) => location.id === id);
            if (loc) {
              return loc;
            }
            try {
                const location = await locationService.getLocation(id).toPromise()
                locations.push(location)
                return location
            } catch(err) {
                console.error(err)
            }

        }
        return null;
    }

    public static makeLocationChoice(location: Location): ControlantChoice {
        return {
            value: location.id,
            label: `${location.name} ${location.reference ? `(${location.reference})` : ''}`,
            selected: false,
            disabled: false,
            customProperties: null
        };
    }

    public static validateSave(element: SubscriptionItem): boolean {
        return element.severityControls.some(
            (checkbox: UntypedFormControl) =>
                checkbox.value === true &&
                (element.originControl.value !== null && element.destinationControl.value !== null)
        );
    }

    public static makeSubscriptionItem(subscription: SubscriptionModel, users: Array<User>, locations: Array<Location>, addedElement: boolean): SubscriptionItem {

        const registeredUser = subscription.userId === null ? null : UserHelpers.findUser(users, subscription.userId);
        return {
            id: subscription.id,
            userLabel: registeredUser ? registeredUser.firstName + ' ' + registeredUser.lastName : subscription.email,
            userComment: registeredUser ? registeredUser.username : '',
            isRegisteredUser: registeredUser !== null,
            origin: subscription.originId === null ? null : SubscriptionHelpers.findLocation(locations, subscription.originId),
            destination: subscription.destinationId === null ? null : SubscriptionHelpers.findLocation(locations, subscription.destinationId),
            severityControls: [
                new UntypedFormControl({value: subscription.subscribeToNoExcursion, disabled: !addedElement}),
                new UntypedFormControl({value: subscription.subscribeToLowExcursion, disabled: !addedElement}),
                new UntypedFormControl({value: subscription.subscribeToMediumExcursion, disabled: !addedElement}),
                new UntypedFormControl({value: subscription.subscribeToHighExcursion, disabled: !addedElement})
            ],
            originControl: new UntypedFormControl(subscription.originId === null ? 'ANY' : subscription.originId),
            destinationControl: new UntypedFormControl(subscription.destinationId === null ? 'ANY' : subscription.destinationId),

            isSaved: false,
            hasError: false,
            addedElement: addedElement,
            elementExists: false,
            inEditMode: addedElement,
            isLoading: subscription.originId !== null && SubscriptionHelpers.findLocation(locations, subscription.originId) === null
                        || subscription.destinationId !== null && SubscriptionHelpers.findLocation(locations, subscription.destinationId) === null,
            removingSubscription: false
        }
    }

    public static async makeSubscriptionItemAsync(subscription: SubscriptionModel, users: Array<User>, locations: Array<Location>, addedElement: boolean, locationService: any): Promise<SubscriptionItem> {

        const registeredUser = subscription.userId === null ? null : UserHelpers.findUser(users, subscription.userId);
        return {
            id: subscription.id,
            userLabel: registeredUser ? registeredUser.firstName + ' ' + registeredUser.lastName : subscription.email,
            userComment: registeredUser ? registeredUser.username : '',
            isRegisteredUser: registeredUser !== null,
            origin: subscription.originId === null ? null : await SubscriptionHelpers.findLocationAsync(locations, subscription.originId, locationService),
            destination: subscription.destinationId === null ? null : await SubscriptionHelpers.findLocationAsync(locations, subscription.destinationId, locationService),
            severityControls: [
                new UntypedFormControl({value: subscription.subscribeToNoExcursion, disabled: !addedElement}),
                new UntypedFormControl({value: subscription.subscribeToLowExcursion, disabled: !addedElement}),
                new UntypedFormControl({value: subscription.subscribeToMediumExcursion, disabled: !addedElement}),
                new UntypedFormControl({value: subscription.subscribeToHighExcursion, disabled: !addedElement})
            ],
            originControl: new UntypedFormControl(subscription.originId === null ? 'ANY' : subscription.originId),
            destinationControl: new UntypedFormControl(subscription.destinationId === null ? 'ANY' : subscription.destinationId),

            isSaved: false,
            hasError: false,
            addedElement: addedElement,
            elementExists: false,
            inEditMode: addedElement,
            isLoading: false,
            removingSubscription: false

        }
    }

    public static filterSubscriptionsByLane(subscriptions: Array<SubscriptionModel>, origin: number | string, destination: number | string): Array<SubscriptionModel> {
        const originParsed = origin === 'ANY' ? null : origin;
        const destinationParsed = destination === 'ANY' ? null : destination;
        return subscriptions.filter(subscription => subscription.originId === originParsed && subscription.destinationId === destinationParsed);
    }

    public static createStateStream(stream) {
        return stream.pipe(
            // Scan merges states to the previous states, so that old state info is never lost.
            scan(
                (acc, curr) => ({
                    state: Object.assign({}, acc.state, curr),
                    lastState: acc.state
                }),
                { state: null, lastState: null }
            )
        );
    }
}
